import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import { buildersInfo } from '../config/builderInfo'
import { theme } from '../theme/theme'

const SeeTransactionPayment = () => {
  const { transaction: transactionId } = useParams()

  const [loading] = useState(false)
  const location = useLocation()

  // const [transaction, setTransaction] = useState(location.state?.transaction || null);
  const transaction = location.state?.transaction || {}



  if (loading) {
    return <p>Loading printing details...</p>
  }

  const handlePrint = () => {
    const element = document.getElementById('print_page')

    // Temporarily adjust styles if necessary
    element.classList.add('print-style')

    // Trigger the print dialog
    window.print()

    // Optionally, revert the style back after printing
    element.classList.remove('print-style')
  }

  const textStyle = {
    fontSize: '14px',
    color: '#6c757d',
    marginBottom: '0rem',
  }

  const signatureStyle = {
    fontSize: '16px',
    marginTop: '6rem',
    marginLeft: '21rem',
    textAlign: 'center',
    fontStyle: 'italic',
  }

  return (
    <>
      <style>
        {`
        /* Hide print button and other elements when printing */
        @media print {
          .no-print {
            display: none;
          }

            /* Hide the sidebar when printing */
          .position-fixed {
          display: none; /* This hides the SideNavbar */
        }

          /* Ensure content takes up the full page */
          body, html {
            height: 100%;
            width: 100%;
            margin: 0;
            padding: 0;
            font-size: 11px;
          }

          #print_page {
            height: 100%;
            width: 150%;
            font-size:15px;
            margin-top: 3px;
            padding: 20px; 
            overflow: hidden; 
            transform: translateX(-50%);
            position: relative; 
            left: 40%;
    
          }
          .ishan-copy {
            margin-left: 7rem;
          } 
          .agent-copy {
            margin-left: 70px;
          }
            
        }
      `}
      </style>
      <Container className="p-5" id="print_page">
        <Row className="justify-content-end">
          <Col xs={12} md={10} lg={10}>
            <div>
              <Container>
                <Row>
                  <Col xs={12} sm={4}>
                    <img
                      src="/ishan.png"
                      alt="ishan logo"
                      className="text-center text-sm-end"
                      style={{ width: '90px' }}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <h2
                      className=" fw-bold mt-0 text-start text-sm-start"
                      style={{ marginBottom: '-1rem', color: theme.colors.primary }}
                    >
                      {buildersInfo.name}
                    </h2>
                    <br />
                    <p
                      className="text-center text-sm-start text-muted"
                      style={textStyle}
                    >
                      {buildersInfo.address}
                    </p>
                    <p className="text-start">Contact : {buildersInfo.contact_number}</p>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '4rem', marginRight: '8rem' }}>
                  <Col>
                    <h4
                      className=" ishan-copy mt-4"
                      style={{ fontSize: '1rem', fontWeight: 'bold', color: theme.colors.secondary }}
                    >
                      {buildersInfo.name} COPY
                    </h4>
                  </Col>
                </Row>

                <Row className="text-center">
                  <Col>
                    <p
                      style={{
                        fontSize: '1.3rem',
                        margin: 0,
                        fontWeight: 'bold',
                      }}
                    >
                      I have received amount
                      <span
                        className="text-danger"
                        style={{ fontWeight: 'bold' }}
                      >
                        {' '}
                        ₹ {transaction?.transaction_amount || 'N/A'}
                      </span>{' '}
                      on{' '}
                      {new Date(
                        transaction?.transaction_date,
                      ).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}{' '}
                      by {transaction?.payment_method || 'N/A'}
                      method for Booking ID{' '}
                      <span style={{ color: 'blue' }}>
                        {transaction?.booking_id}
                      </span>
                    </p>
                  </Col>
                </Row>

                <Row className="text-center mt-5">
                  <Col>
                    <p style={signatureStyle}>
                      <strong className="fw-bold">Signature with stamp</strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: '3rem' }}>
              <div
                className="my-4 border-line" // Margin for spacing
                style={{
                  borderTop: '3px dashed ',
                  width: '100%',
                }}
              ></div>
            </div>
            <div style={{ marginTop: '3rem' }}>
              <Container>
                <Row>
                  <Col xs={12} sm={4}>
                    <img
                      src="/ishan.png"
                      alt="ishan logo"
                      className="text-center text-sm-end"
                      style={{ width: '90px' }}
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <h2
                      className=" fw-bold mt-2 text-start text-sm-start"
                      style={{ marginBottom: '-1rem', color: theme.colors.primary  }}
                    >
                      {buildersInfo.name}
                    </h2>
                    <br />
                    <p
                      className="text-center text-sm-start text-muted"
                      style={textStyle}
                    >
                      {buildersInfo.address}
                    </p>
                    <p className="text-start">Contact : {buildersInfo.contact_number}</p>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '4rem', marginRight: '12rem' }}>
                  <Col>
                    <h4
                      className=" agent-copy mt-4"
                      style={{ fontSize: '1rem', fontWeight: 'bold',color: theme.colors.secondary }}
                    >
                      AGENT'S COPY
                    </h4>
                  </Col>
                </Row>

                <Row className="text-center">
                  <Col>
                    <p
                      style={{
                        fontSize: '1.3rem',
                        margin: 0,
                        fontWeight: 'bold',
                      }}
                    >
                      I have received amount
                      <span
                        className="text-danger"
                        style={{ fontWeight: 'bold' }}
                      >
                        {' '}
                        ₹ {transaction?.transaction_amount || 'N/A'}
                      </span>{' '}
                      on{' '}
                      {new Date(
                        transaction?.transaction_date,
                      ).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                      by {transaction?.payment_method || 'N/A'} method for
                      Booking ID{' '}
                      <span style={{ color: 'blue' }}>
                        {transaction?.booking_id}
                      </span>
                    </p>
                  </Col>
                </Row>

                <Row className="text-center mt-5">
                  <Col>
                    <p style={signatureStyle}>
                      <strong className="fw-bold">
                        Signature with stamp :
                      </strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: '6rem' }}>
              <Button
                variant="outline-secondary"
                className="fw-bold mb-2 no-print"
                onClick={handlePrint}
                style={{ width: '150px' }}
              >
                <i className="bi bi-file-earmark-pdf"></i> Print
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default SeeTransactionPayment


